import { render } from "./SpeedControl.vue?vue&type=template&id=7953ce26"
import script from "./SpeedControl.vue?vue&type=script&lang=js"
export * from "./SpeedControl.vue?vue&type=script&lang=js"
script.render = render

export default script